import { render, staticRenderFns } from "./EvidenceChart.vue?vue&type=template&id=01e57aa4&scoped=true"
import script from "./EvidenceChart.vue?vue&type=script&lang=js"
export * from "./EvidenceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e57aa4",
  null
  
)

export default component.exports